import { render, staticRenderFns } from "./act.vue?vue&type=template&id=52f2be42&scoped=true"
import script from "./act.vue?vue&type=script&lang=js"
export * from "./act.vue?vue&type=script&lang=js"
import style0 from "./act.vue?vue&type=style&index=0&id=52f2be42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2be42",
  null
  
)

export default component.exports